import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';

import ComplianceStore from '../../stores/ComplianceStore';
import { createCompliance, listCompliances } from '../../actions/ComplianceActionCreator';

import DetailView from '../Common/DetailView';
import ComplianceCard from './ComplianceCard';
import AssignUsersDialog from './AssignUsersDialog';
import ClearUsersDialog from './ComplianceClearUsersDialog';
import ComplianceEditDialog from './ComplianceEditDialog';

class ComplianceList extends Component {

    componentDidMount() {
        listCompliances();
    }

    render() {
        const isRootAdmin = this.context.auth.isRootAdmin();
        return (
            <DetailView
                title="Compliance"
                newEntityAction={isRootAdmin ? createCompliance : null}
            >
                <div className="cent-cards">
                    {this.state.items.map(item => (
                        <ComplianceCard key={item.id} {...item} canAssign={this.context.auth.isAdmin()} canEdit={isRootAdmin}/>)
                    )}
                </div>
                <AssignUsersDialog />
                <ClearUsersDialog/>
                <ComplianceEditDialog />
            </DetailView>
        );
    }
}

ComplianceList.getStores = () => ([ComplianceStore]);
ComplianceList.calculateState = (prevState) => ({
    items: ComplianceStore.getList()
});

ComplianceList.contextTypes = {
    auth: PropTypes.object
};
export default Container.create(ComplianceList);
